"use client";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Search } from "lucide-react";
import { useJobFilterStore } from "../../store/useJobFilterStore";
import Button from "../atoms/Button";
import { useJobStore } from "../../store/jobStore";

export default function JobSearchDetail() {
    const location = useLocation();
    const lang = location.pathname.startsWith("/id") ? "id" : "en";

    const {
        jobTypes,
        degrees,
        experienceLevels,
        industries,
        workingTypes,
        countries,
        states,
        cities,
        fetchFilters,
        fetchStates,
        fetchCities,
    } = useJobFilterStore();
    const { setFilters } = useJobStore();

    const [searchJob, setSearchJob] = useState("");
    const [countryId, setCountryId] = useState("");
    const [stateId, setStateId] = useState("");
    const [cityId, setCityId] = useState("");
    const [jobType, setJobType] = useState("");
    const [degree, setDegree] = useState("");
    const [experience, setExperience] = useState("");
    const [industry, setIndustry] = useState("");
    const [workingType, setWorkingType] = useState("");

        const handleCountryChange = async (value: string) => {
        setCountryId(value);
        setStateId("");
        setCityId("");

        if (value) {
            await fetchStates(Number(value), lang);
        }
    };


    const handleStateChange = async (value: string) => {
        setStateId(value);
        setCityId("");

        if (value) {
            await fetchCities(Number(value), lang);
        }
    };

    useEffect(() => {
        fetchFilters(lang);
    }, [lang, fetchFilters]);

    const handleSearch = () => {
        setFilters({
            keyword: searchJob,
            country_id: countryId || undefined,
            state_id: stateId || undefined,
            city_id: cityId || undefined,
            industry_id: industry || undefined,
            job_type_id: jobType || undefined,
            working_type_id: workingType || undefined,
            degree_id: degree || undefined,
            experience_level_id: experience || undefined,
        });
    };
    return (
        <div className="flex-col items-center justify-center text-center h-full md:flex hidden">

            {/* Search Bar */}
            <div className="backdrop-blur-md hidden lg:flex bg-white/20 rounded-2xl shadow-lg p-4 flex-col gap-3 w-full  mx-auto">
                {/* Baris 1 */}
                <div className="flex flex-wrap md:flex-nowrap gap-3 w-full">
                    {/* Search Job */}
                    <div className="flex items-center bg-white rounded-lg px-4 py-2 flex-1">
                        <Search className="h-5 w-5 text-gray-400 mr-2" />
                        <input
                            type="text"
                            placeholder={lang === "id" ? "Cari Pekerjaan..." : "Search Job..."}
                            value={searchJob}
                            onChange={(e) => setSearchJob(e.target.value)}
                            className="w-full bg-transparent outline-none text-gray-700"
                        />
                    </div>

                    {/* Location */}
                    <div className="flex items-center bg-white rounded-lg px-4 py-2 flex-1">
                        <select
                            value={countryId}
                            onChange={(e) => handleCountryChange(e.target.value)}
                            className="bg-white rounded-lg text-primary outline-none flex-1 
    w-full
    min-w-0
    overflow-hidden
    text-ellipsis
    whitespace-nowrap"
                        >
                            <option value="">
                                {lang === "id" ? "Negara" : "Country"}
                            </option>
                            {countries.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                        <select
                            value={stateId}
                            onChange={(e) => handleStateChange(e.target.value)}
                            className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1 
    w-full
    min-w-0
    overflow-hidden
    text-ellipsis
    whitespace-nowrap"
                            disabled={!countryId}
                        >
                            <option value="">
                                {lang === "id" ? "Provinsi / State" : "State"}
                            </option>
                            {states.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                        <select
                            value={cityId}
                            onChange={(e) => setCityId(e.target.value)}
                            className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1 
    w-full
    min-w-0
    overflow-hidden
    text-ellipsis
    whitespace-nowrap"
                            disabled={!stateId}
                        >
                            <option value="">
                                {lang === "id" ? "Kota" : "City"}
                            </option>
                            {cities.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>


                    <select
                        value={industry}
                        onChange={(e) => setIndustry(e.target.value)}
                        className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1"
                    >
                        <option value="">
                            {lang === "id" ? "Industri" : "Industry"}
                        </option>
                        {industries.map((item) => (
                            <option key={item.name} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Baris 2 */}
                <div className="flex flex-wrap md:flex-nowrap gap-3">
                    <select
                        value={jobType}
                        onChange={(e) => setJobType(e.target.value)}
                        className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1"
                    >
                        <option value="">
                            {lang === "id" ? "Jenis Pekerjaan" : "Job Type"}
                        </option>
                        {jobTypes.map((item) => (
                            <option key={item.name} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>

                    <select
                        value={workingType}
                        onChange={(e) => setWorkingType(e.target.value)}
                        className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1"
                    >
                        <option value="">
                            {lang === "id" ? "Tipe Pekerjaan" : "Working Type"}
                        </option>
                        {workingTypes.map((item) => (
                            <option key={item.name} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>

                    <select
                        value={degree}
                        onChange={(e) => setDegree(e.target.value)}
                        className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1"
                    >
                        <option value="">
                            {lang === "id" ? "Pendidikan" : "Degree"}
                        </option>
                        {degrees.map((item) => (
                            <option key={item.name} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>

                    <select
                        value={experience}
                        onChange={(e) => setExperience(e.target.value)}
                        className="
    bg-white rounded-lg px-4 py-2 text-primary outline-none max-w-56
    truncate
  "
                    >
                        <option value="">
                            {lang === "id" ? "Pengalaman" : "Experience"}
                        </option>
                        {experienceLevels.map((item) => (
                            <option key={item.name} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>



                <button
                    onClick={handleSearch}
                    className="bg-primary hover:bg-blue-800 text-white font-semibold rounded-lg px-8 py-2 transition-colors duration-200"
                >
                    {lang === "id" ? "Cari" : "Search"}
                </button>
            </div>
            <div className="backdrop-blur-md lg:hidden  bg-white/20 rounded-2xl shadow-lg p-2 flex flex-col gap-3 w-full max-w-6xl mx-auto">
                {/* Baris 1 */}
                <div className="flex flex-wrap md:flex-nowrap flex-col gap-3 w-full">
                    {/* Search Job */}
                    <div className="flex items-center bg-white rounded-lg px-4 py-2 flex-1">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-gray-400 mr-2"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
                            />
                        </svg>
                        <input
                            type="text"
                            placeholder="Search Job..."
                            value={searchJob}
                            onChange={(e) => setSearchJob(e.target.value)}
                            className="w-full bg-transparent outline-none text-gray-700"
                        />
                    </div>

                    {/* Search Button */}

                </div>

                {/* Baris 2 */}
                <div className="flex flex-wrap md:flex-nowrap gap-3 flex-col">
                   <select
                            value={countryId}
                            onChange={(e) => handleCountryChange(e.target.value)}
                            className="bg-white rounded-lg text-primary outline-none flex-1 
    w-full
    min-w-0
    overflow-hidden
    text-ellipsis
    whitespace-nowrap"
                        >
                            <option value="">
                                {lang === "id" ? "Negara" : "Country"}
                            </option>
                            {countries.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                        <select
                            value={stateId}
                            onChange={(e) => handleStateChange(e.target.value)}
                            className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1 
    w-full
    min-w-0
    overflow-hidden
    text-ellipsis
    whitespace-nowrap"
                            disabled={!countryId}
                        >
                            <option value="">
                                {lang === "id" ? "Provinsi / State" : "State"}
                            </option>
                            {states.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                        <select
                            value={cityId}
                            onChange={(e) => setCityId(e.target.value)}
                            className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1 
    w-full
    min-w-0
    overflow-hidden
    text-ellipsis
    whitespace-nowrap"
                            disabled={!stateId}
                        >
                            <option value="">
                                {lang === "id" ? "Kota" : "City"}
                            </option>
                            {cities.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    <select
                        value={jobType}
                        onChange={(e) => setJobType(e.target.value)}
                        className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1"
                    >
                        <option value="">
                            {lang === "id" ? "Jenis Pekerjaan" : "Job Type"}
                        </option>
                        {jobTypes.map((item) => (
                            <option key={item.name} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>

                    <select
                        value={degree}
                        onChange={(e) => setDegree(e.target.value)}
                        className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1"
                    >
                        <option value="">
                            {lang === "id" ? "Pendidikan" : "Degree"}
                        </option>
                        {degrees.map((item) => (
                            <option key={item.name} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>

                    <select
                        value={experience}
                        onChange={(e) => setExperience(e.target.value)}
                        className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1"
                    >
                        <option value="">
                            {lang === "id" ? "Pengalaman" : "Experience"}
                        </option>
                        {experienceLevels.map((item) => (
                            <option key={item.name} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>

                    <select
                        value={industry}
                        onChange={(e) => setIndustry(e.target.value)}
                        className="bg-white rounded-lg px-4 py-2 text-primary outline-none flex-1"
                    >
                        <option value="">
                            {lang === "id" ? "Industri" : "Industry"}
                        </option>
                        {industries.map((item) => (
                            <option key={item.name} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>

                    <button
                        onClick={handleSearch}
                        className="bg-primary hover:bg-blue-800 text-white font-semibold rounded-lg px-8 py-2 transition-colors duration-200 w-full"
                    >
                        Search
                    </button>
                </div>
            </div>

        </div>
    );
}
